import { ObservableInputsManager } from '@/shared/utils/angular-sdk';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, type OnChanges, type OnInit, type SimpleChanges, type Type } from '@angular/core';
import type { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import type { BasicWidgetConfiguration } from '../../../interfaces/TailoredWidget.interface';
import type { AbstractTailoredBasicWidget } from '../AbstractTailoredBasicWidget.class';
import { BasicWidgetClassStaticProvider } from '../basic-widget-class-static-provider.service';

@Component({
    styleUrls: ['./basic-widget-spawner.scss'],
    selector: 'basic-widget-spawner',
    templateUrl: 'basic-widget-spawner.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe, NgComponentOutlet]
})
export class BasicWidgetSpawnerComponent implements OnInit, OnChanges {
    private _observableInputsManager = new ObservableInputsManager<BasicWidgetSpawnerComponent>(this);
    @Input() config!: BasicWidgetConfiguration;
    config$ = this._observableInputsManager.observe('config');
    @Input() context!: Record<string, any>;
    context$ = this._observableInputsManager.observe('context').pipe(filter(isNotNullish));

    basicWidgetComponent$!: Observable<Type<AbstractTailoredBasicWidget<any>>>;
    basicWidgetComponentConfig: any;

    ngOnInit() {
        this.basicWidgetComponent$ = this.config$.pipe(
            filter(isNotNullish),
            tap(config => this.updateWidgetInputs(config.basicWidgetSetting)),
            map(config => BasicWidgetClassStaticProvider.getWidgetFromBasicWidgetCode(config.code)),
            filter(isNotNullish)
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._observableInputsManager.triggerChanges(changes);
    }

    updateWidgetInputs(params: any) {
        if (params) {
            this.basicWidgetComponentConfig = params;
        }
    }
}
